import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { tuiPure, TuiStringHandler, TuiContext } from '@taiga-ui/cdk';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';
// TODO перенести во внутрь модуля
import { FIELD_TYPES, FieldType } from '@src/app/shared/field';

/** TODO: не используется */
@Component({
  selector: 'contacts-type',
  templateUrl: './contacts-type.component.html',
  styleUrls: ['./contacts-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsTypeComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);

  @Input() loading: boolean = false;
  contactTypes: FieldType[] = Object.values(FIELD_TYPES).filter(fieldType => fieldType.forContacts);

  @tuiPure
  contactTypesStringify(items: ReadonlyArray<FieldType>): TuiStringHandler<TuiContext<number>> {
    const map = new Map(items.map(({ id, description }) => [id, description] as [number, string]));

    return ({ $implicit }: TuiContext<number>) => this.translateService.instant(map.get($implicit) || ' ');
  }
}
